export const filterProjects = [
  {
    id: 3,
    title: "Tailwind",
  },
  {
    id: 4,
    title: "JavaScript",
  },
  {
    id: 5,
    title: "React",
  },
  {
    id: 6,
    title: "SpringBoot",
  },
];
export const filterProjectsIcons = [
  {
    id: 3,
    title: "Tailwind",
    iconPath: "Tailwind.png",
  },
  {
    id: 4,
    title: "JavaScript",
    iconPath: "Javascript.svg",
  },
  {
    id: 5,
    title: "React",
    iconPath: "React.png",
  },
  {
    id: 6,
    title: "SpringBoot",
    iconPath: "spring-boot.svg",
  },
];

export const projectData = {
  Tailwind: [
    {
      projectId: 1,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Razorpay-Clone/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Tailwind.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Razorpay UI Clone",
      projectDescription: "Razorpay UI Clone Using Tailwind CSS [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Razorpay-Clone",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Razorpay-Clone/blob/main/README.md",
      projectLiveLink: "https://razorpay-clone-rp.vercel.app/",
    },
  ],
  JavaScript: [
    {
      projectId: 1,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Weather-App/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Weather App",
      projectDescription:
        "Stay Ahead of the Forecast with Our Weather App [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Weather-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Weather-App/blob/main/README.md",
      projectLiveLink: "https://weather-app-rp.vercel.app/",
    },
    {
      projectId: 2,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Tic-Tac-Toe/raw/main/project-screenshot/tic%20tac%20toe02.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Tic Tac Toe",
      projectDescription: "Where 'X' and 'O' battle for supremacy",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Tic-Tac-Toe",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Tic-Tac-Toe/blob/main/README.md",
      projectLiveLink: "https://tic-tac-toe-rp.vercel.app/",
    },
    {
      projectId: 3,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Password-Generator/raw/main/project-screenshot/password%20generator.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Password Generator",
      projectDescription:
        "Generate a Strong Password For Your Favourite Platforms [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Password-Generator",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Password-Generator/blob/main/README.md",
      projectLiveLink: "https://password-generator-rp.vercel.app/",
    },
    {
      projectId: 4,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Color-Calculator/raw/main/project-screenshot/color%20calculator.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Color Calculator",
      projectDescription: "Generate The Color You Want [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Color-Calculator",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Color-Calculator/blob/main/README.md",
      projectLiveLink: "https://color-calculator-rp.vercel.app/",
    },
    {
      projectId: 5,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Guess-The-Number/raw/main/project-screenshot/guess%20the%20number%2002.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Guess The Number [Game]",
      projectDescription:
        "Challenges player to guess a randomly generated number within a specified range [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Guess-The-Number",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Guess-The-Number/blob/main/README.md",
      projectLiveLink: "https://guess-the-number-rp.vercel.app/",
    },
    {
      projectId: 6,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Dummy-Drums/blob/main/project-screen-shots/ss1%5Blanding%5D.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Dummy Drum",
      projectDescription: "Make Music Rich [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Dummy-Drums",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Dummy-Drums/blob/main/README.md",
      projectLiveLink: "https://dummy-drums-rp.vercel.app/",
    },
    {
      projectId: 7,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/BMI-Calculator/raw/main/project-screenshot/BMI%20calculator.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "BMI - Calculator",
      projectDescription: "Calculate Your Body Mass Index [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/BMI-Calculator",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/BMI-Calculator/blob/main/README.md",
      projectLiveLink: "https://bmi-calculator-rp.vercel.app/",
    },
    {
      projectId: 8,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Share-Modal/raw/main/project-screenshot/share%20modal.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Share Modal",
      projectDescription: "Share Your Profile Easily...",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Share-Modal",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Share-Modal/blob/main/README.md",
      projectLiveLink: "https://share-modal-rp.vercel.app/",
    },
    {
      projectId: 9,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Timecraft/blob/main/project-screen-shots/light-mode%5Blanding%5D.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Time Craft with Dark & Light Theme",
      projectDescription: "Make The Time Light and Dark [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Timecraft",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Timecraft/blob/main/README.md",
      projectLiveLink: "https://timecraft-rp.vercel.app/",
    },
    {
      projectId: 10,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Digital-Clock/raw/main/Project%20Screenshot/digital%20clock.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Digital Clock App",
      projectDescription: "Digital Clock App For Beginner in JS [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Digital-Clock",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Digital-Clock/blob/main/README.md",
      projectLiveLink: "https://digital-clock-rp.vercel.app/",
    },
    {
      projectId: 11,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Counter-App-JS/raw/main/project-screenshot/counter%20app.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Counter App",
      projectDescription:
        "Increment and Decrement App For Beginner In JS [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Counter-App-JS",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Counter-App-JS/blob/main/README.md",
      projectLiveLink: "https://counter-app-js-rp.vercel.app/",
    },
  ],
  React: [
    {
      projectId: 1,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Shopping-Cart-App/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Redux.svg",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Shopping Cart App Using Redux",
      projectDescription:
        "An Efficient state management Using Redux [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Shopping-Cart-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Shopping-Cart-App/blob/main/README.md",
      projectLiveLink: "https://shopping-cart-app-rp.vercel.app/",
    },
    {
      projectId: 2,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Blogs-App/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Blogs App Using Context API",
      projectDescription: "Blogs App Using Context API - React [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Blogs-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Blogs-App/blob/main/README.md",
      projectLiveLink: "https://blogs-app-rp.vercel.app/",
    },
    {
      projectId: 3,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Random-GIF-App/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Random GIF App",
      projectDescription: "Random GIF App By Creating Custom Hook - React",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Random-GIF-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Random-GIF-App/blob/main/README.md",
      projectLiveLink: "https://random-gif-rp.vercel.app/",
    },
    {
      projectId: 4,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Multi-Page-App/raw/main/project-screenshot/Multi%20Page%20App%20-%20Login%20Page.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Multi Page App",
      projectDescription: "Multi Page App Using React Routers",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Multi-Page-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Multi-Page-App/blob/main/README.md",
      projectLiveLink: "https://multi-page-app-rp.vercel.app/",
    },
    {
      projectId: 5,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/User-Form-App/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "User Form App",
      projectDescription: "User Form App Using React [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/User-Form-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/User-Form-App/blob/main/README.md",
      projectLiveLink: "https://user-form-app-rp.vercel.app/",
    },
    {
      projectId: 6,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Top-Courses/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Top Courses",
      projectDescription: "Select Your Favourite Courses [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Top-Courses",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Top-Courses/blob/main/README.md",
      projectLiveLink: "https://top-courses-rp.vercel.app/",
    },
    {
      projectId: 7,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Testimonial-Slider/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Testimonial Slider",
      projectDescription: "Testimonial Slider Using React [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Testimonial-Slider",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Testimonial-Slider/blob/main/README.md",
      projectLiveLink: "https://testimonial-slider-rp.vercel.app/",
    },
    {
      projectId: 8,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Plan-The-Trip/blob/main/project-screenshot/landing.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "CSS.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Plan The Trip",
      projectDescription: "Take a Break & Pack The Snack [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Plan-The-Trip",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Plan-The-Trip/blob/main/README.md",
      projectLiveLink: "https://plan-the-trip-rp.vercel.app/",
    },
    {
      projectId: 9,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Counter-App-React/raw/main/project-screenshot/counter%20app.png?raw=true",
      projectTechStack: [
        "HTML.png",
        "Tailwind.png",
        "Javascript.svg",
        "React.png",
        "Git.svg",
        "Github.svg",
        "Vercel.svg",
      ],
      projectHeading: "Counter App Using React",
      projectDescription:
        "Increment and Decrement App For Beginner In React [Responsive]",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/Counter-App-React",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Counter-App-React/blob/main/README.md",
      projectLiveLink: "https://counter-app-react-rp.vercel.app/",
    },
  ],
  SpringBoot: [
    {
      projectId: 1,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/Bill-Generation-App/blob/main/project-image/bill-generation-image.png?raw=true",
      projectTechStack: ["java.svg", "spring-boot.svg"],
      projectHeading: "Bill Generation System",
      projectDescription:
        "A backend-driven order management app with product categorization, real-time stock tracking, and automated communication workflows. Supports atomic order placement with WhatsApp alerts to users and SMS/email reports to admins based on thresholds and daily activity. Implements normalized data models and pagination for performance.",
      projectGithubLink:
        "https://github.com/Rahul-Bhutaiya/Bill-Generation-App",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/Bill-Generation-App/blob/main/README.md",
    },
    {
      projectId: 2,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/KotakBankApp/blob/master/project_screenshot/banking%20app%20image.png?raw=true",
      projectTechStack: ["java.svg", "spring-boot.svg"],
      projectHeading: "Banking App",
      projectDescription:
        "This Spring Boot-based Banking Application allows users to create an account by providing personal details. Once registered, users can conveniently deposit or withdraw money, view account details and transaction statements, and even transfer funds securely to other users' accounts, offering a complete digital banking experience.",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/KotakBankApp",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/KotakBankApp/blob/master/README.md",
    },
    {
      projectId: 3,
      projectImage:
        "https://github.com/Rahul-Bhutaiya/QuizApp/blob/master/project-screenshot/quiz%20app%20image.png?raw=true",
      projectTechStack: ["java.svg", "spring-boot.svg"],
      projectHeading: "Quiz App",
      projectDescription:
        "The Quiz App is an interactive Spring Boot project that delivers a personalized quiz experience. Users can register to receive a unique session ID and are then served five distinct multiple-choice questions. Results are presented upon completion, and the app supports simultaneous gameplay by multiple users. It highlights backend proficiency in session management, concurrency, and clean entity design.",
      projectGithubLink: "https://github.com/Rahul-Bhutaiya/QuizApp",
      projectReadmeLink:
        "https://github.com/Rahul-Bhutaiya/QuizApp/blob/master/README.md",
    },
  ],
};
